<template>
  <div class="relative" ref="wrapper">
    <div @click="toggle">
      <slot name="action" />
    </div>

    <div v-if="isOpen" class="absolute right-0 top-full z-[2000]" :class="size">
      <Card class="p-4 shadow-lg">
        <slot />
      </Card>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue'

const props = defineProps({
  modelValue: { type: Boolean, default: undefined },
  size: { type: String, default: '' },
})

const emit = defineEmits(['update:modelValue', 'open', 'close', 'toggle'])

const wrapper = ref(null)
const internalOpen = ref(false)

const isControlled = computed(() => typeof props.modelValue === 'boolean')

const isOpen = computed({
  get() {
    return isControlled.value ? props.modelValue : internalOpen.value
  },
  set(v) {
    if (isControlled.value) emit('update:modelValue', v)
    else internalOpen.value = v

    emit('toggle', v)
    emit(v ? 'open' : 'close')
  },
})

function toggle() {
  isOpen.value = !isOpen.value
}

function close() {
  isOpen.value = false
}

function handleClickOutside(event) {
  const el = wrapper.value
  if (event.target?.closest?.('[data-floating-root="true"]')) return
  if (el && !el.contains(event.target)) close()
}

onMounted(() => document.addEventListener('mousedown', handleClickOutside))
onBeforeUnmount(() => document.removeEventListener('mousedown', handleClickOutside))

// se estiver controlled, garante que false fecha (e true abre)
watch(
  () => props.modelValue,
  (v) => {
    if (!isControlled.value) return
    // nada a fazer: isOpen já reflete v. (mantém aqui por clareza/side-effects futuros)
  }
)
</script>
